import { getContactWhatAreYouLookingForTypes } from 'app/services/sfAuth/sfData/sfContact'
import { useEffect, useState } from 'react'

export interface GoalOption {
  label: string
  value: string
}

export const useGoalOption = () => {
  const [goalOptions, setGoalOptions] = useState<GoalOption[]>([])

  useEffect(() => {
    getContactWhatAreYouLookingForTypes().then((types) => {
      setGoalOptions(types)
    })
  }, [])

  return { goalOptions }
}
